import React, { createContext, useContext, useState, useEffect } from 'react';
import { memberAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const data = await memberAPI.getProfile();
      setMember(data);
    } catch (error) {
      setMember(null);
    } finally {
      setLoading(false);
    }
  };

  const login = (memberData) => {
    setMember(memberData);
  };

  const logout = async () => {
    try {
      await memberAPI.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setMember(null);
    }
  };

  const updateMember = (memberData) => {
    setMember(memberData);
  };

  const value = {
    member,
    loading,
    isAuthenticated: !!member,
    login,
    logout,
    updateMember,
    refreshProfile: checkAuth,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

